import React from 'react';

import { Paper } from '@mui/material';

interface Props {
    className?: string;
    style?: React.CSSProperties;
}

const EmptyBox: React.FC<Props> = ({ className, style, children }) => (
    <Paper
        elevation={0}
        className={className || 'vulners-flexbox-center flex1'}
        style={{
            margin: '20px 0',
            width: '100%',
            ...style
        }}
    >
        <div
            style={{
                fontSize: '14px',
                textAlign: 'center',
                display: 'table-cell',
                verticalAlign: 'middle'
            }}
        >
            {children || 'Nothing found'}
        </div>
    </Paper>
);

export default EmptyBox;
